import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import BaseTrigger from 'triggers/BaseTrigger';

const baseString = 'vra-exit-trigger';
const classString = classNames({
  [`${baseString}`]: true
});
let ExitTriggerTankMix = ({
  isVisible,
  dataTestId,
  onClickCancelTrigger
}) => isVisible ? (
  <section className={classString}>
    <BaseTrigger
      className={classString}
      content={getMessage('button-text__cancel')}
      dataTestId={dataTestId}
      handler={onClickCancelTrigger}
      mode='secondary'
    />
  </section>
) : null;

ExitTriggerTankMix.propTypes = {
  dataTestId: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  onClickCancelTrigger: PropTypes.func.isRequired
};
export default ExitTriggerTankMix;
